import { controls } from "../../controls";


const ms251 = {
  label: "Jandhan Accounts",
  pageLabel: "Jandhan Accounts",
  starting: true,
  url: "ms251",
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "Create",
        uid: "create",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isRequired: true, defaultValue: "assigned_branch", width: "col-sm-2" }),

    ...controls.showData({ tab: "filter", data: "branch_display", isRequired: true, name: "branch_display", }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.displayText({ tab: "filter", label: "Group", width: "col-sm-2" }),
    ...controls.Group({ tab: "filter", width: "col-sm-2" }),

    ...controls.showData({ tab: "filter", data: "group_display", name: "group_display", }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.magicDateLabel({ label: "Open Date", width: "col-sm-2" }),
    ...controls.magicDate({ dateType: "ontype", name: "open_date", width: "col-sm-2", default: "sessiondate" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.displayText({ tab: "filter", label: "Number Of Records", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "per_page", placeHolder: "Enter Number Of Records", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", default: true, label: "Active", name: "isActive", width: "col-sm-2" }),


  ],
  form: [
    ...controls.displayText({ tab: "create", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "create", isRequired: true, defaultValue: "assigned_branch", width: "col-sm-2" }),

    ...controls.showData({ tab: "create", data: "branch_display", isRequired: true, name: "branch_display", }),

    ...controls.displayText({ tab: "create", star: true, label: "Group", width: "col-sm-2" }),
    ...controls.Group({ tab: "create", isRequired: true, width: "col-sm-2" }),

    ...controls.showData({ tab: "create", data: "group_display", name: "group_display", }),

    ...controls.displayText({ tab: "create", star: true, label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({ tab: "create", isRequired: true, onChangeSet: { customer_changed: true } }),
    ...controls.showData({ tab: "create", date: "customer_number_display", name: "customer_number_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", star: true, label: "Amount From SB Product", width: "col-sm-2" }),
    ...controls.product({ tab: "create", isRequired: true, width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "product_code_display", name: "product_code_display" }),

    ...controls.displayText({ tab: "create", label: "Amount From SB Account", width: "col-sm-2" }),
    ...controls.AccountNumber({ tab: "create", beforeLeave: ["createAcNo"], }),
    ...controls.displayText({ tab: "create", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "create", star: true, label: "Opening Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "create", isRequired: true, dateType: "ontype", name: "opening_date", width: "col-sm-2", default: "sessiondate" }),
    ...controls.displayText({ tab: "create", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "create", label: "Expiry Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "create", dateType: "ontype", name: "expiry_date", width: "col-sm-2", }),
    ...controls.displayText({ tab: "create", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "create", label: "Close Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "create", dateType: "ontype", name: "close_date", width: "col-sm-2", }),
    ...controls.displayText({ tab: "create", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", label: "Nominee Name", width: "col-sm-2" }),
    ...controls.text({ tab: "create", placeHolder: "Nominee Name", name: "nominee_name", width: "col-sm-2", }),
    ...controls.displayText({ tab: "create", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", label: "Nominee Age", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "create", placeHolder: "Nominee Age", name: "nominee_age", width: "col-sm-2", }),
    ...controls.displayText({ tab: "create", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", label: "Relation of Nominee", width: "col-sm-2" }),
    ...controls.RelationCode({ tab: "create" }),
    ...controls.showData({ tab: "create", data: "relation_code_display", name: "reason_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", label: "Amount", width: "col-sm-2" }),
    ...controls.numtoword({ tab: "create", placeHolder: "Amount", convertedTo: "amount_text", name: "amount", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-2" }),
    // ...controls.showData({ tab: "create", data: "entered_amount_text", name: "entered_amount_text",width: "col-sm-6" }),
    ...controls.displayText({ tab: "create", label: "Amount Transfer On", width: "col-sm-2" }),
    ...controls.numtoword({ tab: "create", placeHolder: "Amount Transfer On", convertedTo: "amount_transfer_on_text", name: "amount_transfer_on", width: "col-sm-2" }),
    // ...controls.showData({ tab: "create", data: "amount_transfer_on", name: "amount_transfer_on",width: "col-sm-6" }),
    ...controls.displayText({ tab: "create", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "create", default: true, label: "Active", name: "isActive", width: "col-sm-2" }),



  ],

  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Branch",
        accessor: "LoginName",
        width: 150
      },
      {
        Header: "Group",
        accessor: "lastname",
        width: 150
      },
      {
        Header: "Group Description",
        accessor: "email"
      },
      {
        Header: "S/B Acc No",
        accessor: "mobile"
      },
      {
        Header: "Full Name",
        accessor: "pfnumber"
      },
      {
        Header: "Debit A/c Name",
        accessor: "EmployeeID"
      },
      {
        Header: "Debit Amount",
        accessor: "EmployeeID"
      },
      {
        Header: "Int YN",
        accessor: "EmployeeID"
      }
    ]
  }
};

export default ms251;
